//import {axiosClient} from '../../main'
import Vue from 'vue'
import Vuesax from 'vuesax'

Vue.use(Vuesax)
//import axios from '../../http/axios/index.js'

export default {
  createdNotification (data) {
    this.$vs.notify({
      title: 'Success',
      text: `tag-${data.name} added suceesfully`,
      iconPack: 'feather',
      icon: 'icon-alert-circle',
      color: 'success'
    })
    
  }
}
